import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Tax, TaxClasses, TaxRate } from 'src/app/models/tax';
import { environment } from 'src/environments/environment';
@Injectable({
	providedIn: 'root'
})
export class TaxService {

	constructor(private http: HttpClient) { }

	url = environment.serverAPI4 + "/api"

	createTaxRule(tax: Tax): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/taxrule`, tax);
	}

	updateTaxRule(tax: Tax): Observable<Response[]> {
		return this.http.put<Response[]>(`${this.url}/taxrule`, tax);
	}

	getTaxDropDown(): Observable<Object> {
		return this.http.get(`${this.url}/taxdropdown`);
	}

	getManageTaxRule(Page: number, size: number, sort): Observable<Object> {
		return this.http.get(`${this.url}/taxrule?page=${Page}&size=${size}&sort=${sort}`);
	}

	searchTaxRule(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/taxrule/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}


	getManageTaxRuleId(taxCalculationRuleId: number): Observable<Object> {
		return this.http.get(`${this.url}/taxrule/${taxCalculationRuleId}`);
	}
	// getTaxRate(): Observable<Object> {
	// 	let url = Constant.serverAPI4 + "/api/taxrate/";
	// 	return this.http.get(`${url}`);
	// }
	getManageTaxRate(Page: number, size: number, sort): Observable<Object> {
		return this.http.get(`${this.url}/taxrate?page=${Page}&size=${size}&sort=${sort}`);
	}

	searchTaxRate(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/taxrate/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	createTaxRate(taxRate: TaxRate): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/taxrate`, taxRate);
	}

	getManageTaxRateId(taxCalculationRateId: number): Observable<Object> {
		return this.http.get(`${this.url}/taxrate/${taxCalculationRateId}`);
	}

	customerTaxClassess(Page: number, size: number, sort): Observable<Object> {
		return this.http.get(`${this.url}/taxclass/CUSTOMER?page=${Page}&size=${size}&sort=${sort}`);
	}
	getTaxClass(): Observable<Object> {
		return this.http.get(`${this.url}/common/taxclass`);
	}

	getTaxClassProduct(): Observable<Object> {
		return this.http.get(`${this.url}/common/taxclass/product`);
	}

	newTaxClassess(taxClass: TaxClasses): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/taxclass`, taxClass)
	}

	updateTaxClasses(classId: number): Observable<Object> {
		return this.http.get(`${this.url}/taxclass/byId/${classId}`);
	}

	productTaxClassess(Page: number, size: number, sort): Observable<Object> {
		return this.http.get(`${this.url}/taxclass/product?page=${Page}&size=${size}&sort=${sort}`);
	}

	taxClassSearch(query, Page: any, size: any, sort: any): Observable<Object> {

		return this.http.get(`${this.url}/taxclass/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}



}
